import { ClientError } from '@london-life/errors';

// what the browser needs from an identity provider; Firebase is the first implementation
export interface BrowserAuthProvider {
  signInWithGoogle(): Promise<string>;
  signInWithEmail(email: string, password: string): Promise<string>;
  signUpWithEmail(email: string, password: string, displayName: string): Promise<string>;
  sendPasswordReset(email: string): Promise<void>;
  sendVerificationEmail(): Promise<void>;
  // after the player clicks the link: a fresh token when the email is now verified, otherwise null
  checkEmailVerified(): Promise<string | null>;
  signOut(): Promise<void>;
}
// a sign-in failure; its code (for example auth/invalid-credential) picks the message in @london-life/errors
export class AuthFlowError extends ClientError {
  constructor(code: string) {
    super({ kind: code === 'auth/network-request-failed' ? 'network' : 'auth', code });
    this.name = 'AuthFlowError';
  }
}
